import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { DollarSign, ArrowLeft } from 'lucide-react';
import FinancialAid from '../components/FinancialAid';

export default function FinancialAidPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  
  const programCode = searchParams.get('program') || 'CNA';
  const preselectedOption = searchParams.get('option') || null; // klarna, pay_now, payment_plan, wioa
  
  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    
    if (!token || !storedUser) {
      navigate(`/register?program=${programCode}&financing=${preselectedOption || ''}`);
      return;
    }
    
    try {
      setUser(JSON.parse(storedUser));
    } catch (e) {
      navigate(`/register?program=${programCode}&financing=${preselectedOption || ''}`);
    }
  }, [navigate, programCode, preselectedOption]);
  
  const handleComplete = (result) => {
    console.log('Financial aid application completed:', result);
    // Could navigate to dashboard or show confirmation
  };
  
  if (!user) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }
  
  return (
    <div className="page-container" style={{ minHeight: '100vh', background: '#f8fafc', paddingTop: '20px', paddingBottom: '40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>
        <button
          onClick={() => navigate(-1)}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            background: 'none', 
            border: 'none', 
            color: '#3b82f6', 
            cursor: 'pointer', 
            marginBottom: '20px',
            fontSize: '1rem'
          }}
        >
          <ArrowLeft size={20} />
          Back
        </button>
        
        <div className="card" style={{ padding: '32px' }}>
          <FinancialAid
            studentId={user.id || user._id || 'guest'}
            programCode={programCode}
            preselectedOption={preselectedOption}
            onComplete={handleComplete}
          />
        </div>
        
        <div style={{ marginTop: '24px', textAlign: 'center', color: '#64748b', fontSize: '0.875rem' }}>
          <p>Questions? Contact us at <strong>901.625.1201</strong> or <strong>medcare.nursing@yahoo.com</strong></p>
          <p>MedCare Nursing Institute & Training Academy Inc.</p>
          <p>3150 E. Shelby Dr, Memphis TN 38118</p>
        </div>
      </div>
    </div>
  );
}
